import React from "react";
import DxfGridComponent from "components/dxf-grid/dxf-grid.component";

import {formatDate, json,withDateFilter} from "helpers/data";

import { changeRequestSourceAtom } from "./changeReq.store";
import { useParams } from "react-router-dom";
import { useUnmount } from "react-use";
import { useRecoilValue } from "recoil";





const ChangeRequests = () => {
  const { id } = useParams();

  const appLicensesSource = useRecoilValue(changeRequestSourceAtom(id!));
  useUnmount(() => appLicensesSource.filter([]));

  return (
    <div className="licensesPage">
      <div className="dataTable">
        <DxfGridComponent
          dataSource={appLicensesSource}
          columns={[
            {
              id: "activatedOn",
                dataType: "date",
              width: "200",
              caption: "browse-apps:myProducts.changeRequest.requestDate",
              calculateDisplayValue: (data: any) => formatDate(data.value),
                calculateFilterExpression: withDateFilter()
            },
            {
              id: "oldDeviceName",
              width: "200",
              caption: "browse-apps:myProducts.changeRequest.oldDeviceName",
              calculateCellValue: (data: any) => data.oldDeviceName
            },
            {
              id: "newDeviceName",
              width: "200",
              caption: "browse-apps:myProducts.changeRequest.newDeviceName",
              calculateCellValue: (data: any) => data.newDeviceName
            },
            {
              id: "oldSerial",
              caption: "browse-apps:myProducts.changeRequest.oldSerialNumber",
              calculateCellValue: (data: any) => data.oldSerial
            },
            {
              id: "newSerial",
              caption: "browse-apps:myProducts.changeRequest.newSerialNumber",
              calculateCellValue: (data: any) => data.newSerial
            },
            {
              id: "RequestChangeDeviceStatus.Status",
              caption: "admin:tags.statusCol",
              calculateCellValue: (data: any) => data.status
            },
            {
              id: "ReasonChangeDevice.Reason",
              width: "200",
              caption: "browse-apps:myProducts.changeRequest.reason",
              calculateCellValue: (data: any) => json(data.reason)
            },
            {
              id: "modifiedDate",
                dataType: "date",
              caption: "browse-apps:myProducts.changeRequest.actionDate",
              calculateDisplayValue: (data: any) => formatDate(data.modifiedDate),
                calculateFilterExpression: withDateFilter("License.ActivateOn")

            },
          ]}
          
        >
        </DxfGridComponent>
      </div>
    </div>
  );
};


export default ChangeRequests;
